var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoriesTransparentSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 515,
    viewBox: "0 0 261 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.153 257.413C143.153 332.753 81.9843 393.921 6.64479 393.921C-68.6948 393.921 -129.863 332.753 -129.863 257.413C-129.863 182.074 -68.6948 120.905 6.64479 120.905C81.9843 120.905 143.153 182.074 143.153 257.413Z",
    fill: "#0089AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-15.957 94.7126L6.64482 0L29.0673 94.7126H-15.957Z",
    fill: "#0089AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0673 420.288L6.64482 515L-15.957 420.288H29.0673Z",
    fill: "#0089AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4215 402.708L94.7225 499.394L41.0879 418.135L83.4215 402.708Z",
    fill: "#0089AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.445 367.73L172.034 454.729L94.0039 396.61L128.445 367.73Z",
    fill: "#0089AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.755 319.475L229.61 386.205L136.332 358.401L158.755 319.475Z",
    fill: "#0089AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.78 263.691L260.111 302.257L163.066 307.998L170.78 263.691Z",
    fill: "#0089AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M163.066 207.006L260.111 212.746L170.78 251.313L163.066 207.006Z",
    fill: "#0089AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.332 156.601L229.61 128.797L158.755 195.526L136.332 156.601Z",
    fill: "#0089AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0039 118.39L172.034 60.2705L128.445 147.27L94.0039 118.39Z",
    fill: "#0089AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0879 96.8633L94.7225 15.4248L83.4215 112.29L41.0879 96.8633Z",
    fill: "#0089AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoriesTransparentSun);
export default __webpack_public_path__ + "static/media/StoriesTransparentSun.0e2fe966e3bbbaa0a3f811423bf26c6d.svg";
export { ForwardRef as ReactComponent };